import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Card, CardContent, Slide, Typography } from '@mui/material'

//components
import OfferCard from 'components/OfferCard'
//constants
import { DEFAULT_REWARDS_SLIDE_TIMEOUT } from 'constants/index'
//styles
import './index.css'
//utils
import { formatPositiveNumber } from 'utils/utils'

const GameCard = ({ game }: any) => {
  const navigate = useNavigate()

  const formattedPiggies = formatPositiveNumber(game.gameHistory.earnedPiggy)
  const formattedCoins = formatPositiveNumber(game.gameHistory.earnedCoins)

  const content = (
    <Card sx={styles.card} onClick={() => navigate(`/games/${game.unifiedAppId}`)}>
      <CardContent sx={styles.cardContent}>
        <div className="favoritesGameCardImageWrap">
          <img className="favoritesGameCardImage" src={game.gameDetails.icon_url} />
        </div>
        <Box sx={styles.contentText}>
          <Typography variant="h2">{game.gameDetails.name}</Typography>
          <Box sx={styles.contentEarned}>
            <Typography variant="h4">Earned:</Typography>
            {formattedPiggies && (
              <Typography variant="h4" className="priceText pig">
                <strong>{formattedPiggies}</strong> <img src="/images/pig.png" />
              </Typography>
            )}
            {formattedCoins && (
              <Typography variant="h4" className="priceText coin">
                <strong>{formattedCoins}</strong> <img src="/images/coin.png" />
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>

      {game.specialOffer && (
        <OfferCard
          game={game}
          isLibrary={true}
          specialOffer={game.specialOffer}
          activatedOffer={game.activatedOffer}
          isAutoSwiping={false}
        />
      )}
    </Card>
  )

  if (game.isSwiping) {
    return (
      <Slide
        direction="right"
        in={true}
        mountOnEnter
        unmountOnExit
        timeout={DEFAULT_REWARDS_SLIDE_TIMEOUT}
      >
        {content}
      </Slide>
    )
  }

  return content
}

const styles = {
  card: {
    borderRadius: '12px',
    boxShadow: '0px 4px 4px 0px #00000040',
    cursor: 'pointer',
  },
  cardContent: {
    display: 'flex',
    gap: '12px',
    boxShadow: 'none',
    padding: '12px 16px',
  },
  contentText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  contentEarned: {
    display: 'flex',
    gap: '8px',
  },
}

export default GameCard
